import { render, staticRenderFns } from "./ExpedicaoModalCiot.vue?vue&type=template&id=70f45a4c&scoped=true"
import script from "./ExpedicaoModalCiot.vue?vue&type=script&lang=js"
export * from "./ExpedicaoModalCiot.vue?vue&type=script&lang=js"
import style0 from "./ExpedicaoModalCiot.vue?vue&type=style&index=0&id=70f45a4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f45a4c",
  null
  
)

export default component.exports